import Cookies from "js-cookie";

const ROOT_ROUTES = new Set([
  "auth",
  "admin",
  "calendar",
  "attendees",
  "content",
  "companies",
  "announcements",
  "policies",
  "team",
  "fixtures",
  "orders",
  "cart",
]);

export function getEventBasePath(pathname = window.location.pathname): string {
  const slug = pathname.split("/")[1] ?? "";
  return !slug || ROOT_ROUTES.has(slug) ? "/" : `/${slug}`;
}

export function getFrontendDomain(): string {
  return (
    import.meta.env.VITE_COOKIE_NAME ||
    window.location.hostname.replace(/\./g, "_")
  );
}

export function getSessionCookieName(): string {
  const basePath = getEventBasePath();
  return basePath === "/"
    ? "FenixToken"
    : `FenixToken_${getFrontendDomain()}__${encodeURIComponent(basePath.slice(1))}`;
}

export function getSessionCookie(): string | undefined {
  return Cookies.get(getSessionCookieName());
}

export function hasEventSession(): boolean {
  return Boolean(getSessionCookie());
}

export function removeSessionCookies(): void {
  const name = getSessionCookieName();
  Cookies.remove(name, { path: "/" });
  const hostname = window.location.hostname;
  for (const domain of ["synkd.life", "clublea.pro", "inspired-mobile.com"]) {
    if (hostname === domain || hostname.endsWith(`.${domain}`)) {
      Cookies.remove(name, { path: "/", domain: `.${domain}` });
    }
  }
}
